class LogoSlider extends HTMLElement {
 
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.style.opacity = "1";
      var carouselSpeed = this.getAttribute("data-speed");
      var swiper = new Swiper(".logo-list-slider--" + this.getAttribute("data-sectionid"), {
        spaceBetween: 30,
        centeredSlides: true,
        speed: carouselSpeed,
        autoplay: {
          delay: 0,
        },
        loop: true,
        slidesPerView: "auto",
        allowTouchMove: false,
        disableOnInteraction: true,
        breakpoints: {
          768: {
            slidesPerView: "auto",
            spaceBetween: 40,
          },
        },
      });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("custom-logo-slider", LogoSlider);

